<template>
  <div data-testid="rfq-countdown" :data-time-limit="timeLimit">
    <v-progress-linear
      v-model="timeLeftPercent"
      :height="height"
      style="pointer-events: none"
      :color="progressColor"
    >
      <span 
        :class="[
          'font-weight-bold',
          'text-subtitle-1',
          'white--text'
        ]"
      >
        {{ $t('quoteInfo.timeLeft').toUpperCase() }}: {{ formattedTimeLeft }}
      </span>
    </v-progress-linear>
  </div>
</template>

<script>
export default {
  props: {
    timeLimit: {
      type: Number,
      required: true
    },
    height: {
      type: [Number, String],
      default: 60
    }
  },
  data () {
    return {
      timePassed: 0,
      initialTimeLeft: 0,
      timerInterval: null,
      timeLeftPercent: 100
    }
  },
  computed: {
    timeLimitFormatted() {
      const timeLimitInSeconds = Math.floor(this.timeLimit / 1000)
      const currentTimeInSeconds = Math.floor(new Date().getTime() / 1000)

      const timeDifferenceInSeconds = timeLimitInSeconds - currentTimeInSeconds;

      return timeDifferenceInSeconds
    },
    formattedTimeLeft() {
      const timeLeft = this.timeLeft
      const minutes = Math.floor(timeLeft / 60)
      let seconds = timeLeft % 60
      if (seconds < 10) {
        seconds = `0${seconds}`
      }
      return `${minutes}:${seconds}`
    },
    timeLeft() {
      return this.initialTimeLeft - this.timePassed
    },
    quarterTime() {
      return this.initialTimeLeft / 4
    },
    greenProgress () {
      return this.timeLeft >= this.fortyPercentProgress
    },
    yellowProgress () {
      return this.timeLeft >= this.fifteenPercentProgress && this.timeLeft < this.fortyPercentProgress
    },
    redProgress () {
      return this.timeLeft < this.fifteenPercentProgress
    },
    fortyPercentProgress () {
      return this.initialTimeLeft * 0.40
    },
    fifteenPercentProgress () {
      return this.initialTimeLeft * 0.15
    },
    progressColor () {
      if (this.greenProgress) {
        return "alive" 
      }
      if (this.yellowProgress) {
        return "orangeColor"
      } 
      return "attention"
    }
  },
  // mounted() {
  //   this.initialTimeLeft = this.timeLimitFormatted
  //   this.startTimer()
  // },
  watch: {
    timeLimit: {
      immediate: true,
      handler () {
        this.resetTimer()
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.timerInterval)
  },
  methods: {
    startTimer() {
      const onePercent = (100 / this.initialTimeLeft) * 1
      this.timerInterval = setInterval(() => {
        this.timePassed += 1
        this.timeLeftPercent = this.timeLeftPercent - onePercent
        if (this.timePassed >= this.initialTimeLeft) {
          clearInterval(this.timerInterval)
          this.$emit("timeDue")
        } 
      }, 1000)
    },
    resetTimer () {
      clearInterval(this.timerInterval)
      this.timePassed = 0
      this.timeLeftPercent = 100
      this.initialTimeLeft = this.timeLimitFormatted
      this.startTimer()
    },
  }
}
</script>